/**
 * /library layout — archive and worksheet detail routes.
 *
 * The bottom-nav Riwayat item maps to /library. /library/riwayat remains
 * available as a compatible deep link to the same archive screen.
 */

import { Stack } from 'expo-router';

export default function LibraryLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
        animation: 'fade',
      }}
    >
      <Stack.Screen name="index" />
      <Stack.Screen name="riwayat" />
      <Stack.Screen name="worksheet/[id]" />
    </Stack>
  );
}
